'use client';

import { c as _c } from "react/compiler-runtime";
import { useOutcomeColor } from '@/hooks/chart/use-outcome-color';
import { outcomeHueToStepVar } from '@/lib/chart/outcome-hue';

/**
 * Legacy shim around `useOutcomeColor` for chart components that pass CSS
 * color strings to charting libraries (recharts, lightweight-charts).
 *
 * Returns an array of `var(--outcome-{hue}-400)` strings (fixed 400-step
 * ramps from `globals.css`), so strokes match the saturated palette in both
 * themes — unlike semantic `text` (700 in light, 400 in dark).
 *
 * @deprecated Prefer `useOutcomeColor` + `outcomeHueToStepVar(hue, 400)` (or
 * another step) for new code. See
 * `frontend/specs/035-outcome-color-palette/supplementary/quickstart.md` §5.
 *
 * @param outcomes - Array of outcomes with title and index.
 * @param colorOverrides - Optional map of outcomeIndex to CSS color string.
 *   When set, the override string is returned verbatim for that index
 *   (bypassing the outcome palette entirely).
 * @returns Array of CSS color strings indexed by outcome position.
 */
export function useChartColors(outcomes, colorOverrides, marketPubkey) {
  const $ = _c(6);
  let t0;
  if ($[0] !== marketPubkey) {
    t0 = {
      marketPubkey
    };
    $[0] = marketPubkey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const colorClasses = useOutcomeColor(outcomes, t0);
  let out;
  if ($[2] !== colorClasses || $[3] !== colorOverrides || $[4] !== outcomes) {
    out = [];
    for (let i = 0; i < outcomes.length; i++) {
      const outcome = outcomes[i];
      if (outcome === undefined) {
        continue;
      }
      const override = colorOverrides?.[outcome.index];
      if (override !== undefined) {
        out.push(override);
        continue;
      }
      const cls = colorClasses[i];
      out.push(cls === undefined ? "" : outcomeHueToStepVar(cls.hue, 400));
    }
    $[2] = colorClasses;
    $[3] = colorOverrides;
    $[4] = outcomes;
    $[5] = out;
  } else {
    out = $[5];
  }
  return out;
}